export default "__VITE_ASSET__23c3487d__"